// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".display-none[data-v-52a7eec0]{display:none}.payment-info__images[data-v-52a7eec0]{display:flex;gap:4px;justify-content:flex-end}.payment-info__images.center[data-v-52a7eec0]{justify-content:center}.payment-info__images[data-v-52a7eec0] img{background-color:#fff;border:1px solid var(--c-gray-100);height:24px;width:auto}.payment-info__images.small[data-v-52a7eec0] img{height:16px;width:auto}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
